












import { Component, Prop, Vue } from "vue-property-decorator";

const LISTA = [
  "Mães e pais que sofrem em relacionamentos conturbados com o(s) filho(s), sejam eles crianças após a fase de alfabetização ou adolescentes",
  "Filhos que, da mesma forma, sofrem ao lidar cotidianamente com mães exigentes demais",
  "Mulheres que não conseguem dominar as interações com seu parceiro, dificultando seu relacionamento amoroso",
  "Mulheres que se irritam ao tentar entender o comportamento do namorado, do crush ou do marido",
  "Homens que querem compreender melhor suas parceiras",
  "Mulheres que estão em busca de um parceiro ideal e não conseguem ter um relacionamento sadio",
  "Mães e pais que estão tentando melhorar os vínculos afetivos com suas crianças e adolescentes.",
  "Pais, padrastros e enteados que têm relação conturbada entre si",
  "Empresários e empreendedores que querem potencializar seu negócio mas não encontram funcionários capacitados para determinadas áreas",
  "Coaches, psicológos e terapeutas que estão em busca de uma alternativa para entender melhor seus pacientes",
  "Pais que estão tendo dificuldade com seus filhos após o período de separação conjugal",
  "Pessoas que não se sentem valorizadas e amadas por outras que estão à sua volta"
];

@Component
export default class extends Vue {
  // @Prop() private msg!: string;
  itens: Array<Item> = [];

  // Lifecycle hook
  mounted() {
    let counter = 0;
    this.itens = LISTA.map(function(item) {
      counter++;
      return new Item(counter, item);
    });
  }
}

class Item {
  numero: number;
  nome: string;
  constructor(numero: number, nome: string) {
    this.numero = numero;
    this.nome = nome;
  }
}
